export default __webpack_public_path__ + "static/media/dashboard1.05ae589a.png";